import React from 'react';
import { toast } from 'react-toastify';
import styles from './Toast.module.scss';
import checkIcon from '../../assets/icon_check.svg';
import closeIcon from '../../assets/icon_close.svg';
import { ReactSVG } from 'react-svg';
import cx from 'classnames';
import { Notification } from '../../domain/Notification';
import NotificationItem from '../NotificationItem/NotificationItem';
import { IntlShape } from 'react-intl';

export const showToast = (content: string, type?: 'success' | 'error') => {
  if (type === 'success') {
    toast.success(
      <div className={styles.toastContainer}>
        <div className={styles.toastTitle}>Success</div>
        <div className={styles.toastContent}>{content}</div>
      </div>,
      {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        closeButton: false,
        icon: (
          <div className={styles.iconContainer}>
            <ReactSVG src={checkIcon} />
          </div>
        ),
      },
    );
    return;
  }

  toast.error(
    <div className={styles.toastContainer}>
      <div className={cx(styles.toastTitle, styles.errorTitle)}>Error</div>
      <div className={styles.toastContent}>{content}</div>
    </div>,
    {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      closeButton: false,
      icon: (
        <div className={cx(styles.iconContainer, styles.errorIcon)}>
          <ReactSVG src={closeIcon} />
        </div>
      ),
    },
  );
};

export const showNotificationToast = (intl: IntlShape, notification: Notification, onOpen: () => void) => {
  toast(
    <div className={styles.toastNotificationContainer}>
      <NotificationItem intl={intl} notification={notification} onOpen={onOpen} compactMode={true} />
    </div>,
    {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      closeButton: false,
      icon: false,
    },
  );
};
